import { cn } from '@skupreme/shared/ui';
import type { HTMLAttributes } from 'react';

/** A form or section title. */
export function StyledFormTitle({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={cn('sk:text-xl sk:font-bold sk:text-primary', className)}
    />
  );
}
